'use client';

import { useState } from 'react';
import { ChevronDown, MapPin, Briefcase, Mail, FileText } from 'lucide-react';

/* Job listings — sourced from the approved hiring sheet.
   Keep in sync if HR adds / removes roles. Each entry maps to one
   accordion row in the JobsAccordion below. */
import { useTranslation } from "@/hooks/useTranslation";
const JOBS = [{
  title: 'SDR',
  location: 'Mumbai / Gurugram / Bangalore',
  experience: '2+ Years',
  jdUrl: 'https://drive.google.com/file/d/1-8Z1C9kcgxtRCh_AclbYC7pwTIAiy_5B/view?usp=sharing'
}, {
  title: 'ORM Executive',
  location: 'Mumbai',
  experience: '1+ Years',
  jdUrl: 'https://drive.google.com/file/d/1ymag1NfhbtWCwhB5rNowxkmqGHISsVBd/view?usp=sharing'
}, {
  title: 'Manager - ORM',
  location: 'Mumbai',
  experience: '4–5 years',
  jdUrl: 'https://docs.google.com/document/d/1WilAYpLcv3gSonFC_AefuMDAXNR-cnafJ6X8TACAdDA/edit?usp=sharing'
}, {
  title: 'Senior Python Developer',
  location: 'Mumbai',
  experience: '3+ Years',
  jdUrl: 'https://drive.google.com/file/d/1X_tvZvgTmWfzOdIpXWxEt1N2Q9dHOcI0/view?usp=sharing'
}, {
  title: 'Customer Success Manager',
  location: 'Mumbai / Gurugram / Bangalore',
  experience: '3+ Years',
  jdUrl: 'https://drive.google.com/file/d/1i_ar7gjAFr-HbRVC2-yz2TJ2c3TdkAIC/view?usp=sharing'
}, {
  title: 'Partnership Manager',
  location: 'Mumbai',
  experience: '3+ Years',
  jdUrl: 'https://drive.google.com/file/d/1L4SMJjOuvUXNU2McKjujJIdC4QqZrKVk/view?usp=sharing'
}, {
  title: 'Customer Support Executive',
  location: 'Mumbai',
  experience: '3+ Years',
  jdUrl: 'https://drive.google.com/file/d/1XtmT95olsQGtJJ2ZSFAH-GKmAS5b2Pbf/view?usp=sharing'
}, {
  title: 'Legal Executive',
  location: 'Mumbai',
  experience: '1+ Years',
  jdUrl: 'https://docs.google.com/document/d/1w9bWVyg1IqmLiTKd0JCemvES8vwXjGMS/edit?usp=sharing&ouid=104732327667538550327&rtpof=true&sd=true'
}, {
  title: 'UX Designer',
  location: 'Mumbai',
  experience: '3+ Years',
  jdUrl: 'https://drive.google.com/file/d/1ygxlHrqVKo4VgSKfZHnrQpySpNFnHe8z/view?usp=sharing'
}, {
  title: 'Enterprise Sales Manager',
  location: 'Gurugram / Bangalore',
  experience: '4+ Years',
  jdUrl: 'https://drive.google.com/file/d/1VHWy9GWSizGbQRrrePvsWVpXzWXcxs_P/view?usp=sharing'
}];
export default function CareersJobs() {
  const {
    t
  } = useTranslation();
  const [openIdx, setOpenIdx] = useState(null);
  return <section className="careers-jobs" id="openings">
      <div className="careers-jobs__head">
        <span className="careers-jobs__kicker">{t("careers.we_are_hiring")}</span>
        <h2 className="careers-jobs__title">{t("careers.open")}</h2>
        <p className="careers-jobs__sub">
          {t("careers.find_your_fit_and_apply_directly_do")}{' '}
          <a href="mailto:careers@locobuzz.com" className="careers-jobs__inlineLink">{t("careers.careerslocobuzzcom")}</a>.
        </p>
      </div>

      <div className="careers-jobs__list">
        {JOBS.map((job, i) => {
        const {
          t
        } = useTranslation();
        const isOpen = openIdx === i;
        return <div key={job.title} className={`careers-job${isOpen ? ' careers-job--open' : ''}`}>
              <button type="button" className="careers-job__head" onClick={() => setOpenIdx(isOpen ? null : i)} aria-expanded={isOpen}>
                <div className="careers-job__headMain">
                  <h3 className="careers-job__title">{job.title}</h3>
                  <div className="careers-job__meta">
                    <span className="careers-job__chip"><MapPin size={12} strokeWidth={2.2} />{job.location}</span>
                    <span className="careers-job__chip"><Briefcase size={12} strokeWidth={2.2} />{job.experience}</span>
                  </div>
                </div>
                <span className="careers-job__toggle" aria-hidden="true">
                  <ChevronDown size={18} strokeWidth={2.4} />
                </span>
              </button>

              {isOpen && <div className="careers-job__body">
                  <dl className="careers-job__details">
                    <div><dt>{t("careers.position")}</dt><dd>{job.title}</dd></div>
                    <div><dt>{t("careers.location")}</dt><dd>{job.location}</dd></div>
                    <div><dt>{t("careers.experience")}</dt><dd>{job.experience}</dd></div>
                  </dl>
                  <div className="careers-job__cta">
                    <a className="careers-job__apply" href={`mailto:careers@locobuzz.com?subject=Application — ${encodeURIComponent(job.title)}`}>
                      <Mail size={14} strokeWidth={2.3} />
                      {t("btn.apply")}
                    </a>
                    <a className="careers-job__jd" href={job.jdUrl} target="_blank" rel="noopener noreferrer">
                      <FileText size={14} strokeWidth={2.3} />
                      {t("careers.job_description")}
                    </a>
                  </div>
                </div>}
            </div>;
      })}
      </div>

      <style jsx>{`
        .careers-jobs {
          max-width: 880px;
          margin: 0 auto;
          padding: 80px 24px;
          font-family: var(--font-inter), system-ui, sans-serif;
        }
        .careers-jobs__head { text-align: center; margin-bottom: 40px; }
        .careers-jobs__kicker {
          display: inline-block;
          font-size: 12px;
          font-weight: 700;
          color: var(--brand);
          text-transform: uppercase;
          letter-spacing: 1.2px;
          margin-bottom: 12px;
        }
        .careers-jobs__title {
          font-size: clamp(28px, 4vw, 40px);
          font-weight: 800;
          color: var(--text-primary);
          letter-spacing: -0.025em;
          line-height: 1.1;
          margin: 0 0 14px;
        }
        .careers-jobs__sub {
          font-size: 15px;
          color: var(--text-body);
          line-height: 1.7;
          margin: 0;
        }
        .careers-jobs__inlineLink { color: var(--brand); font-weight: 600; }

        .careers-jobs__list { display: flex; flex-direction: column; gap: 12px; }

        .careers-job {
          background: #FFFFFF;
          border: 1px solid var(--border-light);
          border-radius: 14px;
          overflow: hidden;
          transition: border-color 0.18s, box-shadow 0.18s;
        }
        .careers-job--open {
          border-color: var(--brand);
          box-shadow: 0 12px 28px rgba(0, 152, 255, 0.08);
        }
        .careers-job__head {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          padding: 18px 22px;
          background: transparent;
          border: none;
          cursor: pointer;
          text-align: left;
          font: inherit;
          color: inherit;
        }
        .careers-job__headMain {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .careers-job__title {
          margin: 0;
          font-size: 17px;
          font-weight: 700;
          color: var(--text-primary);
          letter-spacing: -0.015em;
        }
        .careers-job__meta {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }
        .careers-job__chip {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 4px 10px;
          background: var(--brand-subtle);
          border: 1px solid var(--brand-border);
          border-radius: 100px;
          font-size: 12px;
          font-weight: 600;
          color: var(--brand);
          white-space: nowrap;
        }
        .careers-job__toggle {
          flex-shrink: 0;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: var(--brand-subtle);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          color: var(--brand);
          transition: transform 0.2s, background 0.2s;
        }
        .careers-job--open .careers-job__toggle {
          transform: rotate(180deg);
          background: var(--brand);
          color: #FFFFFF;
        }

        .careers-job__body {
          padding: 4px 22px 22px;
          border-top: 1px solid var(--border-light);
        }
        .careers-job__details {
          margin: 16px 0 18px;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 14px;
        }
        .careers-job__details > div {
          background: #F8FAFF;
          border: 1px solid var(--border-light);
          border-radius: 10px;
          padding: 12px 14px;
        }
        .careers-job__details dt {
          font-size: 10.5px;
          font-weight: 700;
          color: var(--text-muted);
          text-transform: uppercase;
          letter-spacing: 0.6px;
          margin-bottom: 4px;
        }
        .careers-job__details dd {
          margin: 0;
          font-size: 14px;
          font-weight: 600;
          color: var(--text-primary);
        }
        .careers-job__cta {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }
        .careers-job__apply,
        .careers-job__jd {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 18px;
          border-radius: 100px;
          font-size: 13.5px;
          font-weight: 600;
          text-decoration: none;
          transition: transform 0.15s, box-shadow 0.15s;
        }
        .careers-job__apply {
          background: linear-gradient(135deg, #4F6EF7, #6C47F5);
          color: #FFFFFF;
          box-shadow: 0 6px 16px rgba(79, 110, 247, 0.30);
        }
        .careers-job__apply:hover { transform: translateY(-1px); }
        .careers-job__jd {
          background: #FFFFFF;
          border: 1px solid var(--brand-border);
          color: var(--brand);
        }
        .careers-job__jd:hover { background: var(--brand-subtle); }

        @media (max-width: 640px) {
          .careers-jobs { padding: 56px 16px; }
          .careers-job__head { padding: 16px 16px; gap: 10px; }
          .careers-job__title { font-size: 15.5px; }
          .careers-job__body { padding: 4px 16px 18px; }
          .careers-job__details { grid-template-columns: 1fr; gap: 8px; }
          .careers-job__details > div { padding: 10px 12px; }
          .careers-job__cta { flex-direction: column; gap: 8px; }
          .careers-job__apply,
          .careers-job__jd { width: 100%; justify-content: center; }
        }
      `}</style>
    </section>;
}